// extracted by mini-css-extract-plugin
export default {"toggleContainer":"ThemeSwitch_toggleContainer__EU9e3","option":"ThemeSwitch_option__jTbd+","icon":"ThemeSwitch_icon__di4ZN","active":"ThemeSwitch_active__HpNgm"};